<template>
  
  <div><!-- 封装弹框 -->
  <div style="width:740px;margin-left:5px;margin-top:10px">
     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                       <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.searchOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                         <el-form-item class="mb-0">
                              <el-input v-model="idsearchform.keyword"  size="mini"  style="width:150px" :placeholder="$t('searchText.키워드')"></el-input>
                     </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')"  size="mini" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
       
      <div class="mb-2 text-default">*게임유저가 해당시간에 대한 SDAPI 종합내용입니다.</div>
                </div>

               <el-table
              :data="datalist"
              border
              :empty-text="$t('tableText.데이타가없습니다')"
              v-loading="tableLoading">
   
        <el-table-column :label="$t('nav.아이디')"  prop="username" align="center">
       
        </el-table-column>
        <el-table-column :label="$t('newAdd.코드')"  prop="usercode" align="center">
         
        </el-table-column>

         <el-table-column :label="$t('newAdd.베팅금')" prop="tot_bet"  align="center">
          <template slot-scope="scope"><span :class="func(scope.row.tot_bet)">{{ formatMoney(scope.row.tot_bet)}}</span></template>
        </el-table-column>

      

     

        <el-table-column :label="$t('tableText.당첨금')" prop="tot_win" align="center">
          <template slot-scope="scope"><span :class="func(scope.row.tot_win)">{{ formatMoney(scope.row.tot_win)}}</span> </template>
        </el-table-column>
        <el-table-column :label="$t('msg.손익')" prop="tot_margin" align="center">
            <template slot-scope="scope"><span :class="func(scope.row.tot_margin)">{{ formatMoney(scope.row.tot_margin)}}</span> </template>
        </el-table-column>

       
        <el-table-column  :label="$t('msg.알충')" prop="tot_deposit" align="center" >
         <template slot-scope="scope">{{ formatMoney(scope.row.tot_deposit)}} </template>
        </el-table-column>
      
          <el-table-column  :label="$t('msg.알환')" prop="tot_wihdraw" align="center" >
         <template slot-scope="scope">{{ formatMoney(scope.row.tot_wihdraw)}} </template>
        </el-table-column>
      
        
       
      </el-table>
           
</div>

       


  </div>
</template>
<script>
 import layer from './layer.vue';
 import layerNew from '../../components/common/layer-new.vue';
import zpChildDialog from './zp-child-dialog.vue';
  export default{
     components: {
      
      layer,zpChildDialog
    },
    props:{
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
    
    
    
    },
  
      data(){
        return{
          datalist:[],
          dataChildlist:[],
          modelFalse:false,
          tableChildLoading:false,
        tableLoading:false,
          ChildVisible:false,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
           aid:window.sessionStorage.getItem('admin_id'),
            pickerOptions: {
          },
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        idsearchform:{
          time:[],
          keyword:'',
          searchOptions:[
             
             {
              label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            },
               
           
              {
              label:this.$i18n.t("msg.닉네임"),
              value:'mem_name'
            },
            {
              label:this.$i18n.t("msg.예금주"),
              value:'mem_bankname'
            },
            {
              label:this.$i18n.t("msg.핸드폰"),
              value:'mem_hp'
            },
            {
              label:this.$i18n.t("msg.매장"),
              value:'c_code'
            },
            {
              label:this.$i18n.t("msg.총판"),
              value:'a_code'
            },
            {
              label:this.$i18n.t("msg.부본"),
              value:'b_code'
            }
            ,
            {
              label:this.$i18n.t("msg.본사"),
              value:'s_code'
            }
            ,
            {
              label:this.$i18n.t("msg.마스터"),
              value:'m_code'
            }
            ,
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value:'mem_id',
        },
           
          
        }
      },
        created() {
          // this.info.id父组件传给子组件的id值

           this.idsearchform.keyword=this.info.id;

          this.zpManage();
          //console.log('info',this.info.id)



          
             
    },
      methods:{
         zpManage(){
           let s_time="";
          let e_time="";
           if( this.idsearchform.time!=null && this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }
          //console.log('id',id)
            this.tableLoading = true
          let token=window.sessionStorage.getItem('user');
                this.$axios({
                  method:'get',
                  url:this.domain+'/admin/playertransaction?s_time='+s_time+'&e_time='+e_time+'&'+this.idsearchform.value+'='+this.idsearchform.keyword,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              this.tableLoading = false
              

               if(response.data.code==200){
                      
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                      return;
                    }


              let data = response.data.data
              this.datalist = data.data
              this.idsearchform.time=[response.data.s_time,response.data.e_time]
             
                  
                   
                
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
      },
          openIdModel(id){

             if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }
           
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
        Cancel(){
          this.$emit('cancelData')
        },
          func(state){
              if(state > 0){
                return "text-success"
              }else if(state <0){
                 return "text-danger"
              }else if(state ===0){
                 return ""
              }
            },
        idsearchEvent(){
           this.zpManage();
        },
        openSumzp(id){
          
       this.$layer.iframe({
            type: 2,
            title: this.$i18n.t("title.회원리스트"),
            content: {
                content: zpChildDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['780px', '600px'],
           
        });
     
        

        },
        // Save() {
      //           this.$emit('submitData')
      //       },
      //       handleClose() {
      //           this.$emit('handleClose')
      //       }
      
      }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/common/playertransaction.vue